// Module
var code = "<div> <div class=\"name\">Postal Code</div> <template v-if=\"editing == true\"> <text-field :value.sync=\"filter.value\" label=\"Postal Code\"></text-field> </template> <template v-if=\"editing == false\"> Postal Code {{ valueText }} </template> </div>";
// Exports
export default code;